import { render, staticRenderFns } from "./AllDistributorDeleted.vue?vue&type=template&id=38231946&scoped=true"
import script from "./AllDistributorDeleted.vue?vue&type=script&lang=js"
export * from "./AllDistributorDeleted.vue?vue&type=script&lang=js"
import style0 from "./AllDistributorDeleted.vue?vue&type=style&index=0&id=38231946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38231946",
  null
  
)

export default component.exports